import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Region } from '../shared/region.model';
import { FabButtonGroupComponent } from 'src/app/shared/fabbuttongroup/fabbuttongroup.component';
import { ACTIONS, EVENTO, ICONS, LoaderService, NotificationService, TOOLTIPS } from 'src/app/shared/session';
import { RegionService } from '../shared/region.service';

@Component({
  selector: 'app-region-save',
  templateUrl: './region-save.component.html',
})
export class RegionSaveComponent implements OnChanges {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() data: any;
  @Input() titlePage: string;

  formGroupRegion: FormGroup;
  msgErrorGuardar: string;
  obligatorioMsg: string;
  region: Region;
  buttonGroup: any;
  @ViewChild(FabButtonGroupComponent) fabButtonGroupComponent: FabButtonGroupComponent;

  constructor(
    public fb: FormBuilder,
    private loaderService: LoaderService,
    private regionService: RegionService,
    private notificationService: NotificationService
  ) { }

  ngOnChanges() {
    this.initData();
  }

  async initData() {
    this.msgErrorGuardar = 'Error al guardar región';
    this.obligatorioMsg = 'Campo Obligatorio';
    this.buttonGroup = [
      { tooltip: TOOLTIPS.save, icon: ICONS.save, action: ACTIONS.save }
    ];
    this.region = new Region();
    this.setValuesFormBuilder();
    if (this.data != null && this.data.region != null && this.data.region.id != null) {
      this.region = await this.regionService.obtenerRegion(this.data.region.id).toPromise();
      this.setValuesFormBuilder();
    }
  }

  setValuesFormBuilder() {
    this.formGroupRegion = this.fb.group({
      nombre: [this.region.nombre, Validators.compose([Validators.required])],
    });
  }

  formGroupRegionSubmit(event) {
    if (this.formGroupRegion.invalid)
      return;
    if (this.fabButtonGroupComponent.disabled) return;
    this.fabButtonGroupComponent.disabled = true;
    this.region.nombre = event.value.nombre;
    this.guardarRegion();
  }

  async guardarRegion() {
    this.loaderService.show();
    try {
      if (this.data != null && this.data.region != null && this.data.region.id != null) {
        await this.regionService.actualizarRegion(this.region).toPromise();
        this.notificationService.successful("Región actualizada con éxito");
      } else {
        let id = await this.regionService.insertarRegion(this.region).toPromise();
        this.region.id = id;
        this.notificationService.successful("Región registrada con éxito");
      }
      this.data.region = { id: this.region.id };
      this.onChangeEvent.emit({ evento: EVENTO.consultar, data: this.data });
    } catch (error) {
      this.notificationService.error(this.msgErrorGuardar);
      throw error;
    } finally {
      this.loaderService.hide();
      this.fabButtonGroupComponent.disabled = false;
    }
  }
}
